module.exports = __webpack_public_path__ + "img/new-guide-00-2.079167e4.png";